import { z } from 'zod';
import { DeviceGenre } from '@/constants/device';
export const CatalogSelectionSearchSchema = z.object({
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  freeText: z.string().optional(),
  genre: z.nativeEnum(DeviceGenre).optional()
});